module.exports = __webpack_public_path__ + "media/images/icons/flister-icon-bg-9744d457bf3138d0a99ff75b45e06b14.png";